import { Translate } from './translate';

export default Translate;
